import script from "./cBreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./cBreadcrumbItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/components/cmp/cBreadcrumb/cBreadcrumbItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95d6b9f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95d6b9f2', __exports__)) {
    api.reload('95d6b9f2', __exports__)
  }
  
}


export default __exports__